export class MultiLangStrDto {
  constructor(
    public hebrew:string ,
    public english:string,
  ){}
}
